import { Inject, Injectable, LOCALE_ID } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  public locale: string;
  constructor(
    @Inject(LOCALE_ID) locale: string
  ) { 
    this.locale = locale;
  }

  public getLanguage(): string {
    return this.locale || 'es';
  }
}
